import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Assignment, Contact } from '@apaq/orgkit-js';
import { addMinutes } from 'date-fns';
import { Maps } from 'src/app/common/geo/maps';
import { Tax } from 'src/app/math/tax';

export interface AgreementSummary {
  id: string;
  recurrenceRule: string;
  previousExecution: Date;
}

@Component({
  selector: 'app-assignment-preview-dialog',
  templateUrl: './assignment-preview-dialog.component.html',
  styleUrls: ['./assignment-preview-dialog.component.scss']
})
export class AssignmentPreviewDialogComponent {

  @Input() assignment?: Assignment;
  @Input() contact?: Contact;
  @Input() agreementSummaries?: AgreementSummary[] = [];
  @Input() autoNotificationEnabled = false;
  @Input() allowManualNotification = false;
  @Input() taxRate = 25.0;
  @Output() startAssignment = new EventEmitter();
  @Output() completeAssignment = new EventEmitter();
  @Output() skipAssignment = new EventEmitter();
  @Output() editAssignment = new EventEmitter();
  @Output() openContact = new EventEmitter();
  @Output() openReference = new EventEmitter<string>();
  @Output() sendNotification = new EventEmitter();
  @Output() delete = new EventEmitter();
  @Output() lock = new EventEmitter();
  @Output() unlock = new EventEmitter();

  get currency() {
    return 'DKK';
  }

  onStartAssignment() {
    this.startAssignment.emit();
  }

  onCompleteAssignment() {
    this.completeAssignment.emit();
  }

  onSkipAssignment() {
    this.skipAssignment.emit();
  }

  onEditAssignment() {
    this.editAssignment.emit();
  }

  onContactClick() {
    this.openContact.emit();
  }

  onReferenceClick(reference: string) {
    this.openReference.emit(reference);
  }

  onSendNotification() {
    this.sendNotification.emit();
  }

  get total() {
    let result = 0;
    this.assignment?.tasks.forEach(t => result+= t.unitPrice * t.quantity);
    return result;
  }

  get totalWithTax() {
    return Tax.add(this.total, this.taxRate);
  }

  get endTime() {
    let minutes = 0;
    this.assignment?.tasks.forEach(t => minutes+=t.duration);
    return addMinutes(this.assignment!.plan.executionTime, minutes);
  }

  get notes() {
    return this.assignment?.tasks.filter(t => t.note != null && t.note.trim() != '').map(t => t.note);
  }

  getRecurrenceRule(reference: string | undefined) {
    return reference ? this.agreementSummaries?.find(a => a.id === reference)?.recurrenceRule : undefined;
  }

  getPreviousDate(reference: string | undefined) {
    return reference ? this.agreementSummaries?.find(a => a.id === reference)?.previousExecution : undefined;
  } 

  onDelete() {
    this.delete.emit();
  }

  onLock() {
    this.lock.emit();
  }
  
  onUnlock() {
    this.unlock.emit();
  }
  
  mapLink() {
    return Maps.createLink({
      provider: 'apple',
      end: `${this.contact?.street}, ${this.contact?.city}`,
      travelType: 'drive',
      navigate: true,
      mapType: 'standard'
    })
  }

  openMap() {
    window.open(this.mapLink(), '_BLANK')
  }
}
